module.exports = {
    money: (amount, currency = 'CHF') => {
        return (amount && !isNaN(amount)) ? currency + " " + amount.toLocaleString('ch-FR', { minimumFractionDigits: 2 }) : '';
    }
}